import React from "react";
import { IconProps } from "./Icon";

export const SearchPlus = (props: IconProps) => {
  const className = [
    "icon",
    props.size && `icon--${props.size}`,
    props.className
  ]
    .join(" ")
    .trim();

  return (
    <svg className={className} viewBox="0 0 24 25">
      <path
        fill="currentColor"
        d="M14.625 9.1875C14.625 8.90625 14.3438 8.625 14.0625 8.625H10.875V5.4375C10.875 5.15625 10.5938 4.875 10.3125 4.875H9.1875C8.85938 4.875 8.625 5.15625 8.625 5.4375V8.625H5.4375C5.10938 8.625 4.875 8.90625 4.875 9.1875V10.3125C4.875 10.6406 5.10938 10.875 5.4375 10.875H8.625V14.0625C8.625 14.3906 8.85938 14.625 9.1875 14.625H10.3125C10.5938 14.625 10.875 14.3906 10.875 14.0625V10.875H14.0625C14.3438 10.875 14.625 10.6406 14.625 10.3125V9.1875ZM23.8125 22.7812C24.0469 22.5938 24.0469 22.2188 23.8125 21.9844L18.1406 16.3125C18 16.2188 17.8594 16.125 17.7188 16.125H17.1094C18.5625 14.4375 19.5 12.1875 19.5 9.75C19.5 4.40625 15.0938 0 9.75 0C4.35938 0 0 4.40625 0 9.75C0 15.1406 4.35938 19.5 9.75 19.5C12.1875 19.5 14.3906 18.6094 16.125 17.1562V17.7656C16.125 17.9062 16.1719 18.0469 16.2656 18.1875L21.9375 23.8594C22.1719 24.0938 22.5469 24.0938 22.7344 23.8594L23.8125 22.7812ZM17.25 9.75C17.25 13.9219 13.875 17.25 9.75 17.25C5.57812 17.25 2.25 13.9219 2.25 9.75C2.25 5.625 5.57812 2.25 9.75 2.25C13.875 2.25 17.25 5.625 17.25 9.75Z"
      />
    </svg>
  );
};
